import Vue from 'vue'
import Router from 'vue-router'

const Main = () => import('./modules/Layout/index.vue');
const TeacherMain = () => import('@/modules/TeacherModules/Layout/index.vue');
import teacherHomeRoutes from '@/modules/TeacherModules/Home/router.js'


import loginRoutes from '@/modules/Authentication/router'

import homeRoutes from '@/modules/Home/router'

import globalRoutes from '@/modules/Global/router'
import reportViewRoutes from '@/modules/ReportView/router'
import publicRoutes from '@/modules/Public/router'
import expenseRoutes from '@/modules/Expense/router'
import eventsRoutes from '@/modules/Events/router'
import transactionRoutes from '@/modules/Transaction/router'
import applicationRoutes from '@/modules/Application/router.js'
import attachmentRoutes from '@/modules/Attachment/router'

import userRoutes from '@/modules/User/router'
import settingRoutes from '@/modules/Setting/router'
import merchantRoutes from '@/modules/Merchant/router'
import reportRoutes from '@/modules/Report/router'
import adminToolsRoutes from '@/modules/AdminTools/router'


// import inventoryRoutes from '@/modules/Inventory/router' 
import sadqaFinancialAidRoutes from '@/modules/SadqaFinancialAid/router'
import customerRoutes from '@/modules/Customer/router'
import donorsRoutes from '@/modules/Donors/router'
import teacherRoutes from '@/modules/Teacher/router'
// import subjectRoutes from '@/modules/Subject/router'
import classesRoutes from '@/modules/Classes/router'
import classRoomRoutes from '@/modules/ClassRoom/router.js'
import virtualClassRoomRoutes from '@/modules/VirtualClassRoom/router.js'

import studentRoutes from '@/modules/Student/router'
import advancePaymentRoutes from '@/modules/AdvancePayment/router'
import invoiceRoutes from '@/modules/Invoice/router'
import recurringInvoiceRoutes from '@/modules/Subscription/router.js'
import productRoutes from '@/modules/Product/router'
import campaignRoutes from '@/modules/Campaign/router'
import donationCategoryRoutes from '@/modules/DonationCategory/router.js'
import reportCardRoutes from '@/modules/ReportCard/router.js'
import counterRoutes from '@/modules/Counter/router.js'
import zakatAllocationRoutes from '@/modules/ZakatAllocation/router.js'
import masjidTVAdware from '@/modules/MasjidImage/router.js'
import commentRoutes from '@/modules/Comment/router.js'


//view order
import remoteOrderViewRoutes from '@/modules/Order/RemoteOrderView/router'
// import catalogOrderViewRoutes from '@/modules/Order/CatalogOrderView/router'

// rep order
import catalogRoutes from '@/modules/Order/Catalog/router'

// in-house order
import orderRoutes from '@/modules/Order/InHouse/router'

// remote order
import remoteOrderRoutes from '@/modules/Order/Remote/router'

import accountRoutes from '@/modules/Account/router'


const PageNotFound = () => import('./views/PageNotFound.vue');
const CardCollect = () => import('@/modules/Donors/PaymentInfoCollect/CardCollect.vue');
const ClassCardCollect = () => import('@/modules/Customer/components/CardCollect.vue');
const EventInfo = () => import('@/modules/Events/components/EventInfo.vue');
const EventInfoCollect = () => import('@/modules/Events/components/CardCollect.vue');
const Application = () => import('@/modules/Application/view/RemoteCreate.vue');
const Donation = () => import('@/modules/Donation/view/RemoteCreate.vue');
const MasjidDonation = () => import('@/modules/Donation/view/MasjidDonation.vue');
const CampaignView = () => import('@/modules/Campaign/view/Campaign.vue');
const DepartmentView = () => import('@/modules/Classes/components/View.vue');
const CampaignDonate = () => import('@/modules/Campaign/view/Donation/CampaignDonate.vue');
const Adware = () => import('@/modules/MasjidImage/components/Adware.vue')
const TimeScreen = () => import('@/modules/TimeScreen/components/TimeScreen.vue')
const CounterController = () => import('@/modules/Counter/view/Controller.vue')
const CounterView = () => import('@/modules/Counter/view/Counter.vue')
const FinancialAidForm = () => import('@/modules/SadqaFinancialAid/view/FinancialAidForm.vue')

// const Home = () => import('./views/Home.vue');
// const TermsandCondition = () => import('./views/TermsandCondition.vue');
// const ContactUs = () => import('./views/ContactUs.vue');
// const Pricing = () => import('./views/Pricing.vue');


Vue.use(Router);

let mainRoutes = []
let mainTeacherRoutes = []
mainTeacherRoutes = mainTeacherRoutes.concat(teacherHomeRoutes)

mainRoutes = mainRoutes.concat(homeRoutes)
mainRoutes = mainRoutes.concat(settingRoutes)
mainRoutes = mainRoutes.concat(merchantRoutes)
mainRoutes = mainRoutes.concat(userRoutes)
mainRoutes = mainRoutes.concat(expenseRoutes)
mainRoutes = mainRoutes.concat(eventsRoutes)
mainRoutes = mainRoutes.concat(transactionRoutes)
mainRoutes = mainRoutes.concat(attachmentRoutes)
mainRoutes = mainRoutes.concat(applicationRoutes)


// view in software
// mainRoutes = mainRoutes.concat(catalogOrderViewRoutes)
mainRoutes = mainRoutes.concat(remoteOrderViewRoutes)

// // rep order
// mainRoutes = mainRoutes.concat(catalogRoutes)

// // remote order
// mainRoutes = mainRoutes.concat(remoteOrderRoutes)

// in-house Order
mainRoutes = mainRoutes.concat(orderRoutes)


// mainRoutes = mainRoutes.concat(inventoryRoutes)
mainRoutes = mainRoutes.concat(sadqaFinancialAidRoutes)
mainRoutes = mainRoutes.concat(customerRoutes)
mainRoutes = mainRoutes.concat(donorsRoutes)
mainRoutes = mainRoutes.concat(studentRoutes)
mainRoutes = mainRoutes.concat(advancePaymentRoutes)
mainRoutes = mainRoutes.concat(teacherRoutes)
// mainRoutes = mainRoutes.concat(subjectRoutes)
mainRoutes = mainRoutes.concat(classesRoutes)
mainRoutes = mainRoutes.concat(classRoomRoutes)
mainRoutes = mainRoutes.concat(virtualClassRoomRoutes)
mainRoutes = mainRoutes.concat(invoiceRoutes)
mainRoutes = mainRoutes.concat(recurringInvoiceRoutes)
mainRoutes = mainRoutes.concat(productRoutes)
mainRoutes = mainRoutes.concat(reportRoutes)
mainRoutes = mainRoutes.concat(adminToolsRoutes)
mainRoutes = mainRoutes.concat(campaignRoutes)
mainRoutes = mainRoutes.concat(donationCategoryRoutes)
mainRoutes = mainRoutes.concat(reportCardRoutes)
mainRoutes = mainRoutes.concat(counterRoutes)
mainRoutes = mainRoutes.concat(masjidTVAdware)
mainRoutes = mainRoutes.concat(zakatAllocationRoutes)
mainRoutes = mainRoutes.concat(commentRoutes)



let routes = [{
    path: '/',
    component: Main,
    children: mainRoutes,
  },
  {
    path: '/t',
    component: TeacherMain,
    children: mainTeacherRoutes,
  },
  {
    path: '/p/:id',
    name: 'classCardCollect',
    component: ClassCardCollect,
  },



  {
    path: '/e/:id',
    name: 'EventInfo',
    component: EventInfo,
  },

  {
    path: '/e/:id/apply',
    name: 'EventInfo',
    component: EventInfoCollect,
  },

  {
    path: '/d/p/:id',
    name: 'cardCollect',
    component: CardCollect,
  },
  {
    path: '/a/:id',
    name: 'application',
    component: Application,
  },
  {
    path: '/donation/:id',
    name: 'collectDonation',
    component: MasjidDonation,
  },
  {
    path: '/go/:id',
    name: 'collectDonationByCampaign',
    component: CampaignView,
  },
  {
    path: '/go/:id/donate',
    name: 'collectDonationByCampaignDonate',
    component: CampaignDonate,
  },
  {
    path: '/dep/:code/:id',
    name: 'depView',
    component: DepartmentView,
  },
  {
    path: '/student-sponsor/:id',
    name: 'donation',
    component: Donation,
  },
  {
    path: '/tv/:code',
    name: 'adware',
    component: Adware,
  },
  {
    path: '/timeScreen/:code',
    name: 'timeScreen',
    component: TimeScreen,
  },
  {
    path: '/counter-controller/:id',
    name: 'controller',
    component: CounterController,
  },
  {
    path: '/c/:id',
    name: 'counter-view',
    component: CounterView,
  },
  {
    path: '/financialAid/:id/:code',
    name: 'financial-form-view',
    component: FinancialAidForm,
  },
  // {
  //   path: '/pricing',
  //   name: 'pricing',
  //   component: Pricing,
  // },
  // {
  //   path: '/termsandcondition',
  //   name: 'termsandCondition',
  //   component: TermsandCondition,
  // },
  {
    path: '*',
    name: 'pagenotfound',
    component: PageNotFound,
  },
]


routes = routes.concat(publicRoutes)
routes = routes.concat(globalRoutes)
routes = routes.concat(reportViewRoutes)
routes = routes.concat(remoteOrderRoutes)
routes = routes.concat(catalogRoutes)
routes = routes.concat(loginRoutes)
routes = routes.concat(accountRoutes)


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return {
      x: 0,
      y: 0
    }
  },
})

router.beforeEach((to, from, next) => {
  // document.title = 'taleem - Online Inventory Software, CRM Lead & Inventory Management, Sales Rep Software'
  // console.log('to', to)
  const loginToken = localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)
  if (loginToken || to.name === 'authentication-login') {
    next()
  } else {
    if (to.name === "home") {
      next({
        name: "login"
      });
    } else {
      // next("/login");
      next()
    }
    // next()
  }

})

export default router
